import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

export const EmptyAttributes = () => (
  <Stack direction="column" alignItems="center" justifyContent="center" gap="0.5rem" py="1.5rem">
    <InfoOutlined color="disabled" sx={{ fontSize: 48 }} />

    <Typography variant="body2" color="text.secondary">
      Attributes are not configured for Stage
    </Typography>
  </Stack>
);
